

































































































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {writeExcel} from '@/utils/excel';
import {getToday, addMonth, changeDateFormat} from '@/utils/dateUtils';
import {namespace, State} from 'vuex-class';
import {i18nInObjectList} from '@/utils/i18n';
import {ncpPopup} from '@/utils/ncp';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

import {
  Mall,
  GetMallsResponse,
  GetInquiriesRequest,
  GetInquiryTypeRequest,
  GetInquiryTypesInquiryTypeNoRequest,
  Assignees,
  InquiryType,
  Inquiry
} from 'supporter';
import ClickOutside from 'vue-click-outside';
import {masking} from '@/utils/commonUtils';
const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    CompSelectBox,
    PeriodDateCalendar,
    CompCheckBox,
    ItemTable,
    ExcelCreateButton
  },
  directives: {
    ClickOutside
  }
})
export default class InquiryList extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<GetMallsResponse>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private inquiriesContents: Inquiry[] = [];
  private inquiriesExcelContents: Inquiry[] = [];
  private totalCount: number = 0;
  private inquiriesContentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    onLoadSearch: false,
    name: 'inquiry_list'
  };
  // 검색어
  private searchTypes = [
    {
      searchTypeValue: 'ALL',
      searchTypeName: 'COMMON_ALL'
    },
    {
      searchTypeValue: 'INQUIRY_NO',
      searchTypeName: 'INQUIRY_INQUIRY_SEARCHTYPE_1'
    },
    {
      searchTypeValue: 'TITLE',
      searchTypeName: 'INQUIRY_INQUIRY_SEARCHTYPE_2'
    },
    {
      searchTypeValue: 'ISSUER',
      searchTypeName: 'INQUIRY_INQUIRY_SEARCHTYPE_3'
    },
    {
      searchTypeValue: 'ASSIGNEE',
      searchTypeName: 'INQUIRY_INQUIRY_SEARCHTYPE_4'
    }
  ];

  private inquiryStatusList = {
    name: 'inquiryStatusList',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'INQUIRY_INQUIRY_COMPCHECKBOX_1'
      },
      {
        id: 'ISSUED',
        value: 'ISSUED',
        dispaly: 'INQUIRY_INQUIRY_COMPCHECKBOX_2'
      },
      {
        id: 'ANSWERED',
        value: 'ANSWERED',
        dispaly: 'INQUIRY_INQUIRY_COMPCHECKBOX_3'
      },
      {
        id: 'IN_PROGRESS',
        value: 'IN_PROGRESS',
        dispaly: 'INQUIRY_INQUIRY_COMPCHECKBOX_4'
      }
    ]
  };

  private startDateTime: string = addMonth(new Date(), -3);
  private endDateTime: string = getToday();

  private getInquirysRequest: GetInquiriesRequest = {
    params: {
      page: 1,
      pageSize: 30,
      mallNo: this.malls && this.malls[0].mallNo,
      inquiryStatuses: 'ALL'
    }
  };

  private getInquirysExcelRequest: GetInquiriesRequest = {
    params: {}
  }

  private initRequest() {
    this.getInquirysRequest = {
      params: {
        mallNo: this.malls && this.malls[0].mallNo,
        page: 1,
        pageSize: 30,
        searchType: 'ALL',
        keyword: '',
        inquiryTypeNo: undefined,
        assigneeNo: undefined,
        inquiryStatuses: 'ALL',
        startDateTime: undefined,
        endDateTime: undefined
      }
    };
  }

  private inquiryTypes: InquiryType[] = [];
  private assignees: Assignees[] = [];

  get getInquiryTypeRequest(): GetInquiryTypeRequest {
    return {
      params: {
        mallNo: Number(this.getInquirysRequest.params.mallNo)
      }
    };
  }

  private getInquiryTypes() {
    this.$api.getInquiryType(this.getInquiryTypeRequest).then(ret => {
      this.inquiryTypes = ret.data;
    });
  }

  private changeMall() {
    this.getInquiryTypes();
  }

  get getInquiryTypesInquiryTypeNoRequest(): GetInquiryTypesInquiryTypeNoRequest {
    return {
      pathParams: {
        inquiryTypeNo: this.getInquirysRequest.params.inquiryTypeNo.toString()
      },
      params: {
        mallNo: Number(this.getInquirysRequest.params.mallNo)
      }
    };
  }

  private changeInquiryType() {
    this.$api.getInquiryTypesInquiryTypeNo(this.getInquiryTypesInquiryTypeNoRequest).then(ret => {
      let selectedInquiry = ret.data;
      if (selectedInquiry) {
        this.assignees = [...selectedInquiry.assignees]
          .sort((a,b)=>a.name>b.name?1:-1)
          .map(({name, id, no})=> (
          {
            id,
            no,
            name: `${name}(${id})`,
          }
        ));
      }
    });
  }

  private openPop() {
    let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
    if (checkedRows.length === 0) {
      alert(this.$t('INQUIRY_INQUIRY_ALERT_SELECT_NONE'));
      return;
    }
    // Channel只有空和NCP，如果出现不等则提示

    // let selectChanels = checkedRows.map(row => {
    //   let selectedinquiryType = this.inquiryTypes.find(item => item.no === row.inquiryTypeNo);
    //   selectedinquiryType && selectedinquiryType.channel != null ? selectedinquiryType.channel : '';
    // });

    if (!checkedRows.map(inquiry => inquiry.inquiryTypeChannel || 'NCP').reduce((a, b) => (a == b ? a : false))) {
      alert(this.$t('INQUIRY_INQUIRY_ALERT_SELECT_NCP'));
      return;
    }

    // 所选项目的Channel全部相等则返回Channel，否则返回默认值
    let selectedinquiryTypeNo = checkedRows[0].inquiryTypeNo;

    if (!checkedRows.map(inquiry => inquiry.inquiryTypeChannel || 'NAVER_PAY').reduce((a, b) => (a === b ? a : false))) {
      selectedinquiryTypeNo = undefined;
    }

    let queryString = '?inquiryNos=';
    queryString += checkedRows.map((item: any) => item.inquiryNo).join(',');
    queryString += '&mallNo=' + this.getInquirysRequest.params.mallNo;
    queryString += '&inquiryTypeNo=' + selectedinquiryTypeNo;
    
    if(checkedRows[0].inquiryTypeChannel){
      // Channel存在则发送
      queryString += '&channel=' + checkedRows[0].inquiryTypeChannel;
    }
    queryString += '&callback=membersCallback';
    (window as any).membersCallback = this.callback;
    let path = `/inquiry/popup/typeAndAdmin${queryString}`;
    ncpPopup(path, this.$t('INQUIRY_INQUIRY_POP_TITLE'), 623, 500);
  }

  private openDetail(inquiryNo) {
    let queryString = inquiryNo + '?&mallNo=' + this.getInquirysRequest.params.mallNo;
    queryString += '&callback=inquiryDetail';
    (window as any).inquiryDetail = this.inquiryDetailPopupCallback;
    let path = `/inquiry/popup/${queryString}`;
    ncpPopup(path, this.$t('INQUIRY_INQUIRY_ITEMTABLE_T4_POP'), 1024, 800);
  }

  private openIssuerDetail(issuerNo) {
    let path = `/member/popup/crm/${issuerNo}`;
    ncpPopup(path, this.$t('INQUIRY_INQUIRY_ITEMTABLE_T5_POP'), 1100, 980);
  }

  private callback() {
    (window as any).membersCallback = undefined;
    this.search(1);
  }

  private inquiryDetailPopupCallback() {
    (window as any).inquiryDetailPopupCallback = undefined;
    this.search(1);
  }

  private reset() {
    this.initRequest();
    (this.$refs.combinedPeriod as any).clickPeriod('3m');
    this.startDateTime = addMonth(new Date(), -3);
    this.endDateTime = getToday();
    (this.$refs.isinquiryStatus as any).setValues('ALL');
  }

  private searchMallNo = '';
  private size: number = 30;
  // 조회
  private async search(page: number = 1, size?: number) {
    if (size) {
      this.size = size;
    }

    this.getInquirysRequest.params.page = page;
    this.getInquirysRequest.params.pageSize = this.size;

    Object.assign(this.getInquirysRequest.params, {
      startDateTime: this.startDateTime + ' 00:00:00',
      endDateTime: this.endDateTime + ' 23:59:59'
    });

    const {inquiryStatuses} = this.getInquirysRequest.params;
    this.getInquirysRequest.params.inquiryStatuses = inquiryStatuses === 'ALL' ? 'ISSUED,ANSWERED,IN_PROGRESS' : inquiryStatuses;

    this.getInquirysExcelRequest.params = {
      searchType: this.getInquirysRequest.params.searchType,
      keyword: this.getInquirysRequest.params.keyword,
      inquiryTypeNo: this.getInquirysRequest.params.inquiryTypeNo,
      mallNo: this.getInquirysRequest.params.mallNo,
      issuerNo: this.getInquirysRequest.params.issuerNo,
      assigneeNo: this.getInquirysRequest.params.assigneeNo,
      inquiryStatuses: this.getInquirysRequest.params.inquiryStatuses,
      startDateTime: this.getInquirysRequest.params.startDateTime,
      endDateTime: this.getInquirysRequest.params.endDateTime,
      page: 1,
      pageSize: null 
    };

    let {data} = await this.$api.getInquiries(this.getInquirysRequest);
    // this.getInquirysRequest.params.inquiryStatuses = inquiryStatuses === 'ISSUED,ANSWERED,IN_PROGRESS' ? 'ALL' : inquiryStatuses;
    this.inquiriesContents = data.contents;
    this.totalCount = data.totalCount;

    this.inquiriesGridResult.options.pageOptions.page = page;
    this.inquiriesGridResult.options.pageOptions.perPage = this.size;
    this.inquiriesGridResult.options.pageOptions.totalCount = data.totalCount;
    this.searchMallNo = Number(this.getInquirysRequest.params.mallNo).toString();
  }

  private  inquiriesGridResult = {
    columns: [
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH1',
        name: 'mall',
        align: 'center',
        minWidth: 5,
        formatter: (cell: any) => {
          return cell.row.mallName;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH2',
        name: 'issuedDateTime',
        align: 'center',
        minWidth: 85
        // formatter: (cell: any) => {
        //   return new Date(format(cell.value, 'yyyy-MM-dd 00:00:00'));
        // }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH3',
        name: 'inquiryNo',
        align: 'center',
        minWidth: 5
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH4',
        name: 'inquiryTitle',
        align: 'left',
        minWidth: 200,
        formatter(cell: any) {
          // return `<a style="text-decoration: underline;" href="javascript:window.open(
          //   '/inquiry/popup/${cell.row.inquiryNo}?mallNo=${cell.row.mallNo}&callback=inquiryDetailPopupCallback',
          //   '${window.$t('INQUIRY_INQUIRY_ITEMTABLE_T4_POP')}', '${centerWinOptions( 1024, 800)}');" >${cell.value}</a>`;
          return `<a style="text-decoration: underline;" href="javascript:openDetail(${cell.row.inquiryNo});" >${cell.value}</a>`;
        }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH5',
        name: 'issuer',
        align: 'center',
        minWidth: 120,
        formatter: (cell: any) => {
          const href = cell.row.issuer ? `javascript:openIssuerDetail(${cell.row.issuer.issuerNo});` : 'javascript:void(0)';
          if (cell.row.external && cell.row.external.naverPay) {
            const issuer = `${cell.row.external.naverPay.writerName} (${masking(cell.row.external.naverPay.naverId,3)})`;
            return `<a style="text-decoration: underline;"  href="${href}">${issuer}</a>`;
          }

          if (cell.row.issuer) {
            // if (cell.memberStatus == 'EXPELLED') {
            //     return window.$t('INQUIRY_INQUIRY_ITEMTABLE_T5_NOTNULL');;
            // }
            if (cell.row.issuer.issuerId && cell.row.issuer.issuerType === 'MEMBER') {
              return `<a style="text-decoration: underline;" href="${href}">${cell.row.issuer.issuerId} (${cell.row.issuer.issuerNo})</a>`;
            }
            if (cell.row.issuer.issuerId && cell.row.issuer.issuerType === 'ADMIN') {
              return `<span>${cell.row.issuer.issuerId} (${cell.row.issuer.issuerTeamName})</span>`
            }
            return `<a style="text-decoration: underline;" href="${href}">${cell.row.issuer.issuerNo}</a>`;

          } else {
            if (cell.row.issuer.issuerEmail) {
              return cell.row.issuer.issuerEmail;
            } else {
              return window.$t('INQUIRY_INQUIRY_ITEMTABLE_T5_NULL');
            }
          }
        },
        copyOptions: {
          customValue: (value): string => {
            if (value) {
              if (value.issuerId != '') {
                return `${value.issuerId} (${value.issuerNo})`;
              } else {
                return value.issuerNo;
              }
            } else {
              if (value.issuerEmail) {
                return value.issuerEmail;
              } else {
                return window.$t('INQUIRY_INQUIRY_ITEMTABLE_T5_NULL');
              }
            }
          }
        }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH6',
        name: 'inquiryTypeName',
        align: 'center',
        minWidth: 95,
        formatter(cell: any) {
          if (cell) {
            return cell.value;
          }

          return window.$t('INQUIRY_INQUIRY_ITEMTABLE_T6_NULL');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH7',
        name: 'assignee',
        align: 'center',
        minWidth: 50,
        formatter(cell: any) {
          return (cell.row.assignee && cell.row.assignee.assigneeName) || '';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH8',
        name: 'inquiryStatus',
        align: 'center',
        minWidth: 40,
        formatter(cell: any) {
          if (cell.value == 'ANSWERED') return window.$t('INQUIRY_INQUIRY_COMPCHECKBOX_3');
          if (cell.value == 'IN_PROGRESS') return window.$t('INQUIRY_INQUIRY_COMPCHECKBOX_4');
          if (cell.value == 'ISSUED') return window.$t('INQUIRY_INQUIRY_COMPCHECKBOX_2');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'INQUIRY_INQUIRY_ITEMTABLE_TH9',
        name: 'answeredDateTime',
        align: 'center',
        minWidth: 85,
        formatter(cell: any) {
          if (cell.row.inquiryStatus == 'ANSWERED') return cell.value;
        },
        copyOptions: {
          useFormattedValue: true
        }
      }
    ],
    options: {
      columnOptions: {
        resizable: true,
        minWidth: 50
      },
      rowHeaders: [
        'checkbox',
        {
          type: 'rowNum',
          width: 60
        }
      ],
      header: {
        height: 33
      },
      displayRowCount: 20,
      minRowHeight: 31,
      bodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    }
  };

  protected async downloadExcel(): Promise<any> {
    if (this.inquiriesContents.length == 0) {
      alert(this.$t('COMMON_NOT_DATA'));
      return;
    }
    let keyMapJson = {
      index: 'No.',
      mallName: this.$t('COMMON_MALL'),
      issuedDateTime: this.$t('INQUIRY_INQUIRY_TH_4'),
      inquiryNo: this.$t('INQUIRY_INQUIRY_SEARCHTYPE_1'),
      inquiryTitle: this.$t('INQUIRY_INQUIRY_SEARCHTYPE_2'),
      inquiryContent: this.$t('INQUIRY_INQUIRY_EXCEL_T6'),
      issuer: this.$t('INQUIRY_INQUIRY_ITEMTABLE_TH5'),
      inquiryTypeName: this.$t('INQUIRY_INQUIRY_ITEMTABLE_TH6'),
      assigneeName: this.$t('INQUIRY_INQUIRY_ITEMTABLE_TH7'),
      inquiryStatus: this.$t('INQUIRY_INQUIRY_ITEMTABLE_TH8'),
      answeredDateTime: this.$t('INQUIRY_INQUIRY_ITEMTABLE_TH9'),
      answeredContent: this.$t('INQUIRY_INQUIRY_EXCEL_T12'),
      smsSendSuccess: this.$t('INQUIRY_INQUIRY_EXCEL_T13'),
      emailSendSuccess: this.$t('INQUIRY_INQUIRY_EXCEL_T14')
    } as any;

    let formatters = {
      issuer: (cell: any): string => {
        if (cell.row.issuer) {
          // if (cell.memberStatus == 'EXPELLED') {
          //     return window.$t('INQUIRY_INQUIRY_ITEMTABLE_T5_NOTNULL');;
          // }
          if (cell.row.issuer.issuerId != '') {
            return `${cell.row.issuer.issuerId} (${cell.row.issuer.issuerNo})`;
          } else {
            return `${cell.row.issuer.issuerNo}`;
          }
        } else {
          if (cell.row.issuer.issuerEmail) {
            return cell.row.issuer.issuerEmail;
          } else {
            return window.$t('INQUIRY_INQUIRY_ITEMTABLE_T5_NULL');
          }
        }
      },
      inquiryTitle: (cell: any): string => {
        return cell.value ? cell.value : '';
      },
      inquiryContent: (cell: any): string => {
        return cell.value ? cell.value : '';
      },
      inquiryStatus: (cell: any): string => {
        if (cell.row.inquiryStatus === 'ANSWERED') {
          return window.$t('INQUIRY_INQUIRY_COMPCHECKBOX_3');
        } else if (cell.row.inquiryStatus === 'IN_PROGRESS') {
          return window.$t('INQUIRY_INQUIRY_COMPCHECKBOX_4');
        } else if (cell.row.inquiryStatus === 'ISSUED') {
          return window.$t('INQUIRY_INQUIRY_COMPCHECKBOX_2');
        } else {
          return '';
        }
      },
      assigneeName: (cell: any): string => {
        if (cell.row.assignee && cell.row.assignee.assigneeName) {
          return cell.row.assignee.assigneeName != '' ? cell.row.assignee.assigneeName : ''; 
        } else {
          return '';
        }
      },
      answeredDateTime: (cell: any): string => {
        return cell.row.inquiryStatus === 'ANSWERED' ? cell.value : '';
      },
      answeredContent: (cell: any): string => {
        return cell.value ? cell.value : '';
      },
      smsSendSuccess: (cell: any): string => {
        if (cell.row.inquiryStatus === 'ANSWERED') {
          if (cell.value) {
            return window.$t('INQUIRY_INQUIRY_EXCEL_T13_Y');
          } else {
            return window.$t('INQUIRY_INQUIRY_EXCEL_T13_N');
          }
        } else {
          return '';
        }
      },
      emailSendSuccess: (cell: any): string => {
        if (cell.row.inquiryStatus === 'ANSWERED') {
          if (cell.value) {
            return window.$t('INQUIRY_INQUIRY_EXCEL_T13_Y');
          } else {
            return window.$t('INQUIRY_INQUIRY_EXCEL_T13_N');
          }
        } else {
          return '';
        }
      }
    };
    let {data} = await this.$api.getInquiries(this.getInquirysExcelRequest);
    this.inquiriesExcelContents = data.contents;
    this.inquiriesExcelContents.forEach((elem, index) => {
      Object.assign(elem, {index: index+1});
    });
    let fileName = 'inquiry_';
    fileName += changeDateFormat(new Date(), 'YYYYMMDD_HHmmss');
    writeExcel(this.inquiriesExcelContents, keyMapJson, fileName, formatters);
  }

  private async created() {
    this.inquiriesGridResult = i18nInObjectList(this, this.inquiriesGridResult, 'columns', 'header');
  }

  private async mounted() {
    await this.fetchMalls();
    await this.initRequest();
    await this.getInquiryTypes();
    await this.search(1);
    (window as any).openDetail = this.openDetail;
    (window as any).openIssuerDetail = this.openIssuerDetail;
    this.keypressEnterEvent();
  }

  private keypressEnterEvent() {
    $('.search_field').on('keyup', 'input', e => {
      e.preventDefault();
      if(e.keyCode == 13 && $('#search_btn').length > 0) {
        $('#search_btn').trigger('click');
      } else {
        return;
      }
    });
  }
}
